// extracted by mini-css-extract-plugin
export default {"totalOccupation":"TableBlock_totalOccupation__9o+-H","averageSession":"TableBlock_averageSession__KwKgM","table":"TableBlock_table__KGWiH"};